import { SxProps } from '@mui/material'
import { brandColors } from '../Components/Common/Color/Color'

const buttonStyles: Record<string, SxProps> = {
  containedPrimary: {
    backgroundColor: brandColors.purpleDeluge,
    color: 'white',
    '&:hover': {
      backgroundColor: brandColors.purpleDark,
    },
    '&:disabled': {
      backgroundColor: brandColors.purplePaleLavender,
      color: 'white',
    },
  },
  containedSecondary: {
    backgroundColor: brandColors.greenSanFelix,
    color: 'white',
    '&:hover': {
      backgroundColor: brandColors.greenAccessible,
    },
    '&:disabled': {
      backgroundColor: brandColors.greenMutedGreen,
      color: 'white',
    },
  },
}

export default buttonStyles
